import * as React from "react";

import type { DesignaliProps } from "../types";

export const Instagram = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          d="M12,3.8c2.67,0,2.99.01,4.04.06.98.04,1.5.21,1.86.34.47.18.8.4,1.15.75.35.35.57.68.75,1.15.14.35.3.88.34,1.86.05,1.05.06,1.37.06,4.04s-.01,2.99-.06,4.04c-.04.98-.21,1.5-.34,1.86-.18.47-.4.8-.75,1.15-.35.35-.68.57-1.15.75-.35.14-.88.3-1.86.34-1.05.05-1.37.06-4.04.06s-2.99-.01-4.04-.06c-.98-.04-1.5-.21-1.86-.34-.47-.18-.8-.4-1.15-.75-.35-.35-.57-.68-.75-1.15-.14-.35-.3-.88-.34-1.86-.05-1.05-.06-1.37-.06-4.04s.01-2.99.06-4.04c.04-.98.21-1.5.34-1.86.18-.47.4-.8.75-1.15.35-.35.68-.57,1.15-.75.35-.14.88-.3,1.86-.34,1.05-.05,1.37-.06,4.04-.06ZM12,2c-2.72,0-3.06.01-4.12.06-1.06.05-1.79.22-2.43.46-.66.26-1.22.6-1.77,1.15-.56.56-.9,1.11-1.15,1.77-.25.64-.42,1.36-.46,2.43-.05,1.07-.06,1.41-.06,4.12s.01,3.06.06,4.12c.05,1.06.22,1.79.46,2.43.26.66.6,1.22,1.15,1.77.56.56,1.11.9,1.77,1.15.64.25,1.36.42,2.43.46,1.07.05,1.41.06,4.12.06s3.06-.01,4.12-.06c1.06-.05,1.79-.22,2.43-.46.66-.26,1.22-.6,1.77-1.15.56-.56.9-1.11,1.15-1.77.25-.64.42-1.36.46-2.43.05-1.07.06-1.41.06-4.12s-.01-3.06-.06-4.12c-.05-1.06-.22-1.79-.46-2.43-.26-.66-.6-1.22-1.15-1.77-.56-.56-1.11-.9-1.77-1.15-.64-.25-1.36-.42-2.43-.46-1.07-.05-1.41-.06-4.12-.06ZM12,6.86c-2.84,0-5.14,2.3-5.14,5.14s2.3,5.14,5.14,5.14,5.14-2.3,5.14-5.14-2.3-5.14-5.14-5.14ZM12,15.33c-1.84,0-3.33-1.49-3.33-3.33s1.49-3.33,3.33-3.33,3.33,1.49,3.33,3.33-1.49,3.33-3.33,3.33ZM17.34,5.46c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2,1.2-.54,1.2-1.2-.54-1.2-1.2-1.2Z"
        />
      </svg>
    );
  },
);

export default Instagram;
